const purchaseOrdersTypes = {
  PURCHASE_ORDERS_TABLE_STATE_SET: 'PURCHASE_ORDERS/TABLE_STATE_SET',
  PURCHASE_ORDERS_TABLE_STATE_RESET: 'PURCHASE_ORDERS/TABLE_STATE_RESET',
};
export default purchaseOrdersTypes;
